import { render, staticRenderFns } from "./RegieAnswer.vue?vue&type=template&id=7461517e&scoped=true&"
import script from "./RegieAnswer.vue?vue&type=script&lang=js&"
export * from "./RegieAnswer.vue?vue&type=script&lang=js&"
import style0 from "./RegieAnswer.vue?vue&type=style&index=0&id=7461517e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7461517e",
  null
  
)

export default component.exports